import { render, staticRenderFns } from "./ShoppingCart.vue?vue&type=template&id=f5522d90&scoped=true&lang=pug&"
import script from "./ShoppingCart.vue?vue&type=script&lang=js&"
export * from "./ShoppingCart.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCart.vue?vue&type=style&index=0&id=f5522d90&lang=sass&nolang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5522d90",
  null
  
)

export default component.exports